module.exports = __webpack_public_path__ + "img/settings-norwin-icon.b6f73018.svg";